import React from 'react';
import { Card } from '@/components/ui';

interface DetailStatGridProps {
  children: React.ReactNode;
  minColWidth?: string;
}

export const DetailStatGrid: React.FC<DetailStatGridProps> = ({
  children,
  minColWidth = '160px'
}) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: `repeat(auto-fit, minmax(${minColWidth}, 1fr))`,
      gap: '0.5rem'
    }}
  >
    {children}
  </div>
);

interface DetailStatCardProps {
  title: string;
  children: React.ReactNode;
}

export const DetailStatCard: React.FC<DetailStatCardProps> = ({ title, children }) => (
  <Card className="tw-h-full">
    <Card.Body className="tw-p-2">
      <Card.Subtitle>{title}</Card.Subtitle>
      <div className="tw-mb-0">{children}</div>
    </Card.Body>
  </Card>
);
